import { all, call } from "redux-saga/effects";

import { rootSaga as uiV2RootSaga } from "./inheritFromWeeb-ui-v2/state/rootSaga";
import { authSagas } from "./auth/sagas";
import { callSagas } from "./call/sagas";
import { featureFlagSagas } from "./feature_flagging/sagas";
import { localRecordingSagas } from "./local_recording/sagas";
import { storyAuthoringSagas } from "./story_authoring/sagas";
import { storiesSagas } from "./stories/sagas";

function* _rootSaga() {
  yield all([
    call(storyAuthoringSagas),
    call(callSagas),
    call(authSagas),
    call(featureFlagSagas),
    call(localRecordingSagas),
    call(uiV2RootSaga),
    call(storiesSagas),
  ]);
}

export function rootSaga(): ReturnType<typeof _rootSaga> {
  return _rootSaga();
}
